module.exports = __webpack_public_path__ + "img/ht.97ab227b.png";